export function assertNever(x: any): never {
  throw new Error(
    `Unexpected value. Should have been never. Actual value: ${x}. Actual type: ${typeof x}.`
  );
}
